export default __webpack_public_path__ + "static/media/tvwatcher.73ac598a.PNG";